import React from "react";
import classes from "./CarSkill.module.css";

const CardSkill = ({ text, classCard, img, blackText, time }) => {
  return (
    <div
      className={classes.CardSkill}
      style={{ height: time !== undefined ? "236px" : "206px" }}
    >
      <div className={classes.CardSkillInt}>
        <img src={img} alt={text} />
      </div>

      <div className={`${classes.CardSkillBottom} ${classes[classCard]}`}>
        {blackText ? <span className="black">{text}</span> : text}
      </div>
      {time !== undefined && <p className={classes.CardTime}>{time}</p>}
    </div>
  );
};

export default CardSkill;
